import { isNativeApp, safeExportName } from './platform';

function blobBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Unable to prepare this file.'));
    reader.onload = () => resolve(String(reader.result).split(',')[1]);
    reader.readAsDataURL(blob);
  });
}

// Only our own exported files are removed, never documents selected by the user.
export async function cleanExportCache() {
  if (!isNativeApp()) return;
  const { Filesystem, Directory } = await import('@capacitor/filesystem');
  try {
    const listing = await Filesystem.readdir({ path: 'erp-exports', directory: Directory.Cache });
    const cutoff = Date.now() - 24 * 60 * 60 * 1000;
    await Promise.all(listing.files.filter(file => file.type === 'file' && file.mtime < cutoff).map(file => Filesystem.deleteFile({ path: `erp-exports/${file.name}`, directory: Directory.Cache })));
  } catch { /* A fresh install has no export cache. */ }
}

export async function exportBlob(blob, filename) {
  try {
    const name = safeExportName(filename);
    if (!isNativeApp()) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url; link.download = name;
      document.body.appendChild(link); link.click(); link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      import('../services/auditService').then(service => service.recordExportActivity()).catch(() => {});
      return true;
    }
    if (blob.size > 25 * 1024 * 1024) throw new Error('This export is larger than 25 MB. Use the website for this file.');
    const [{ Filesystem, Directory }, { Share }] = await Promise.all([import('@capacitor/filesystem'), import('@capacitor/share')]);
    const path = `erp-exports/${Date.now()}-${Math.random().toString(36).slice(2, 9)}-${name}`;
    const saved = await Filesystem.writeFile({ path, directory: Directory.Cache, data: await blobBase64(blob), recursive: true });
    // Keep the cache file briefly so the receiving app can finish reading it.
    await Share.share({ title: name, files: [saved.uri], dialogTitle: 'Save or share ERP export' });
    import('../services/auditService').then(service => service.recordExportActivity()).catch(() => {});
    return true;
  } catch (error) {
    if (!/cancel/i.test(error.message || '')) window.alert(error.message || 'Unable to export this file.');
    return false;
  }
}
